var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.3121 0.388672H7.7C3.104 0.388672 0.5 2.99267 0.5 7.58867V20.1887C0.5 24.7847 3.104 27.3887 7.7 27.3887H20.3121C24.908 27.3887 27.5 24.7847 27.5 20.1887V7.58867C27.5 2.99267 24.908 0.388672 20.3121 0.388672Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1362 15.8984C9.3492 15.8984 6.96875 16.329 6.96875 18.0498C6.96875 19.7719 9.33406 20.2172 12.1362 20.2172C14.9233 20.2172 17.3038 19.7867 17.3038 18.066C17.3038 16.3438 14.9385 15.8984 12.1362 15.8984Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.1381 14.2577C14.0363 14.2577 15.5574 12.768 15.5574 10.9091C15.5574 9.05022 14.0363 7.56055 12.1381 7.56055C10.2406 7.56055 8.71875 9.05022 8.71875 10.9091C8.71875 12.768 10.2406 14.2577 12.1381 14.2577Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.936 10.9691C16.936 11.9158 16.6457 12.799 16.1366 13.5328C16.0836 13.6082 16.1304 13.7099 16.2226 13.7261C16.3505 13.747 16.482 13.7598 16.6161 13.7625C17.9509 13.7969 19.1486 12.9554 19.4795 11.688C19.9701 9.80757 18.5308 8.11914 16.6973 8.11914C16.4985 8.11914 16.3079 8.13935 16.1222 8.17641C16.0967 8.1818 16.0692 8.19393 16.0554 8.21548C16.0375 8.24311 16.0506 8.27882 16.0684 8.3024C16.6196 9.05903 16.936 9.98005 16.936 10.9691Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8769 16.1171C20.6327 15.6072 20.0431 15.2574 19.146 15.0857C18.7228 14.9846 17.5767 14.8411 16.511 14.8613C16.4951 14.8633 16.4862 14.8741 16.4848 14.8808C16.4828 14.8916 16.4876 14.9078 16.5082 14.9192C17.0008 15.1577 18.9045 16.1953 18.6651 18.3837C18.6548 18.4794 18.7325 18.5602 18.8295 18.5467C19.298 18.4814 20.5034 18.2274 20.8769 17.4378C21.0841 17.02 21.0841 16.5349 20.8769 16.1171Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.17cc95702b42e8907cb57dc15d208282.svg";
export { ForwardRef as ReactComponent };